"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
const scale_1 = require("../../utils/scale");
const IconPost = (props) => (React.createElement(react_native_svg_1.default, { width: (0, scale_1.scale)(22), height: (0, scale_1.scale)(22), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement(react_native_svg_1.Mask, { id: "mask0_7295_2797", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: (0, scale_1.scale)(22), height: (0, scale_1.scale)(22) },
        React.createElement(react_native_svg_1.Rect, { width: (0, scale_1.scale)(22), height: (0, scale_1.scale)(22), fill: "white" })),
    React.createElement(react_native_svg_1.G, { mask: "url(#mask0_7295_2797)" },
        React.createElement(react_native_svg_1.Path, { d: "M7.5625 16.2721H14.4375V14.8971H7.5625V16.2721ZM7.5625 12.6054H14.4375V11.2305H7.5625V12.6054ZM4.125 19.7096V2.29297H13.0625L17.875 7.10542V19.7096H4.125ZM12.375 7.79292H16.5L12.375 3.66795V7.79292Z", fill: "#FEFEFE" }))));
exports.default = IconPost;
